import request from '@/helper/request'

// 删除购物车
export function delShopcar(id) {
  const data = {
    req: {
      ids: id
    }
  }
  return request({
    url: '/json/cart/delete',
    method: 'post',
    data: data
  })
}

//添加商品到购物车

export function addShopcar(data) {
  return request({
    url: '/json/cart/add',
    method: 'post',
    data: data
  })
}

// export function addShopcar() {
//   const data = {
//       "req": {
//       "product_id": 0,
//       "number": 3
//       }

//   }
//   return request({
//     url: "/json/cart/add",
//     method: "post",
//     data: data,
//   });
// }

//修改购物车内产品数量

export function editShopcar(id, newValue) {
  const editReq = {
    req: {
      id: id,
      info: {
        number: newValue
      }
    }
  }
  return request({
    url: '/json/cart/edit',
    method: 'post',
    data: editReq
  })
}

//查询指定购物车信息

export function readShopcar() {
  const data = {}
  return request({
    url: '/json/cart/read',
    method: 'post',
    data: data
  })
}

//  查询购物车模型字段数据

export function fieldsShopcar() {
  const data = {}
  return request({
    url: '/json/cart/read',
    method: 'post',
    data: data
  })
}

//列表分页及搜索
export function Shopcarlist(data) {
  return request({
    url: '/json/cart/list',
    method: 'post',
    data: data
  })
}

//列表分页及搜索
export function comparelist(data) {
  return request({
    url: '/json/compare/list',
    method: 'post',
    data: data
  })
}

//列表分页及搜索
export function addToCompare(data) {
  return request({
    url: '/json/compare/add',
    method: 'post',
    data: data
  })
}
//列表分页及搜索
export function deleteCompare(data) {
  return request({
    url: '/json/compare/delete',
    method: 'post',
    data: data
  })
}

//购物车数量变化
export function shoppingCarCountChange(data) {
  return request({
    url: '/json/cart/edit',
    method: 'post',
    data: data
  })
}
